/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { run } from './run';
import { transactionMetaExist } from './transactionMeta';
import { startTransaction } from './startTransaction';
import { getFlowSpecification } from './flow';
import { AuthSdkError } from '../errors';
import { IdxFeature, IdxStatus, } from '../types';
export function register(authClient, options = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        // Only check at the beginning of the transaction
        if (!transactionMetaExist(authClient)) {
            const { enabledFeatures, availableSteps } = yield startTransaction(authClient, Object.assign({ flow: 'register' }, options));
            if (!options.activationToken && enabledFeatures && !enabledFeatures.includes(IdxFeature.REGISTRATION)) {
                const error = new AuthSdkError('Registration is not supported based on your current org configuration.');
                return { status: IdxStatus.FAILURE, error };
            }
            if (options.activationToken && (availableSteps === null || availableSteps === void 0 ? void 0 : availableSteps.some(({ name }) => name === 'identify'))) {
                const error = new AuthSdkError('activationToken is not supported based on your current org configuration.');
                return { status: IdxStatus.FAILURE, error };
            }
        }
        const flowSpec = getFlowSpecification(authClient, 'register');
        return run(authClient, Object.assign(Object.assign({}, options), flowSpec));
    });
}
